import { Flex, Title, Space } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ScatterChart } from 'components/Charts/ScatterChart/ScatterChart';
import { BarChart } from 'components/Charts/BarChart/BarChart';
import { MoreMetricsPopOver } from 'components/MoreMetricsPopover/MoreMetricsPopover';
import { HeartRateBarOptions, HeartRateScatterOptions } from 'components/Charts/ChartOptions/HeartrateChartOptions';
import { useHeartRhythmOverview } from 'hooks/api/useHeartRhythmData';
import { PaperWithBorder } from 'components/PaperWithBorder';
import { usePatientDetailContext } from 'context/hooks';

export const HeartRateCharts = () => {
  const { t } = useTranslation();
  const { startDate, endDate } = usePatientDetailContext();
  const { data: measurements, isLoading, handleSelected: onClick } = useHeartRhythmOverview();
  const scatterOptions = HeartRateScatterOptions({ startDate, endDate, onClick, measurements });
  const barOptions = HeartRateBarOptions({ startDate, endDate, measurements });

  return (
    <PaperWithBorder isLoading={isLoading} testId={'heart-rate-charts'}>
      <Flex mb={'xs'} justify={'space-between'} align={'center'}>
        <Title order={4}>{t('patients_heartrate_title')}</Title>
        <MoreMetricsPopOver />
      </Flex>
      <ScatterChart chartOptions={scatterOptions} />
      <Space m={'xs'} />
      <Flex mb={'xs'} justify={'space-between'} align={'center'}>
        <Title order={4}>{t('patients_symptom_severity')}</Title>
      </Flex>
      <BarChart chartOptions={barOptions} />
    </PaperWithBorder>
  );
};
